// Race definitions and stats
export const Races = {
    human: {
        name: 'Mensen',
        color: 0x4169E1,
        health: 100,
        moveSpeed: 5,
        weaponColor: 0x888888,
        attackDamage: 12,
        description: 'Gebalanceerd ras met goede technologie'
    },
    orc: {
        name: 'Orks',
        color: 0x228B22,
        health: 120,
        moveSpeed: 4,
        weaponColor: 0x654321,
        attackDamage: 15,
        description: 'Brute kracht en melee focus'
    },
    elf: {
        name: 'Elven',
        color: 0xFFD700,
        health: 80,
        moveSpeed: 6,
        weaponColor: 0xFFA500,
        attackDamage: 10,
        description: 'Snel en behendig met magie'
    },
    troll: {
        name: 'Trollen',
        color: 0x8B4513,
        health: 200,
        moveSpeed: 2.5,
        weaponColor: 0x4B4B4B,
        attackDamage: 18,
        description: 'Zeer sterk maar langzaam'
    },
    wizard: {
        name: 'Wizard',
        color: 0x9D4EDD,
        health: 250, // Veel meer health dan andere rassen
        moveSpeed: 6.5, // Sneller dan andere rassen
        weaponColor: 0xFF00FF,
        attackDamage: 35, // Veel meer damage dan andere rassen
        description: 'Het beste ras - Krachtige magie en verhoogde stats'
    }
};

